import Message from '../message/Message';
import OverlayStyled from './OverlayStyled';
import PropTypes from 'prop-types';
import React from 'react';
import SquareButton from '../squareButton/SquareButton';
import epicTracking from 'epic-tracking';
import root from 'window-or-global';
import {getVbucksRedirectURL} from '../../utils/route';
import qs from 'query-string';

const Overlay = ({image, close, upperCaseCode, handleSubmit, link}) => {
  const goToRedeem = React.useCallback(() => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'RedeemCode',
      eventAction: 'redirectTo-vbuckscard',
    });
    const [, linkQueryString] = link.split('?');
    const linkQuery = qs.parse(linkQueryString || '');
    root.location.href = getVbucksRedirectURL(root.location, {...linkQuery, code: upperCaseCode});
  }, [upperCaseCode, link]);

  return (
    <OverlayStyled className="overlay">
      <div className="overlay-wrapper">
        <span className="overlay-close" onClick={close} role="presentation" />
        <div className="overlay-content">
          <div className="overlay-content-wrapper">
            <div className="overlay-content-block">
              <h1>
                <Message code="epic.code.redemption.validate.couldBePosa.message" />
              </h1>
              <Message code="epic.code.redemption.validate.couldBePosa.needHelp" />
            </div>
            <div className="overlay-content-block">
              <img alt="V-Bucks Card" src={image} />
            </div>
          </div>
          <div className="buttons-container">
            <SquareButton
              handleClick={goToRedeem}
              config={{buttonStyle: 'btn-primary', width: '240px', centered: true}}>
              <Message code="epic.code.redemption.validate.couldBePosa.cta" />
            </SquareButton>
            <SquareButton
              handleClick={handleSubmit}
              config={{buttonStyle: 'btn-default', width: '240px', centered: true}}>
              <Message code="epic.code.redemption.validate.couldBePosa.continue" />
            </SquareButton>
          </div>
        </div>
      </div>
    </OverlayStyled>
  );
};

Overlay.propTypes = {
  close: PropTypes.func,
  handleSubmit: PropTypes.func,
  image: PropTypes.string,
  upperCaseCode: PropTypes.string,
  link: PropTypes.string,
};

export default Overlay;
